// Where the browser goes after the login callback. The sign-in start keeps the
// page that asked for it in the login state; only a local path is followed.
var LoginReturn = (function() {
  var MAX_LENGTH = 2000;
  // A single leading "/" (not "//" or "/\"), then no backslash, space or control
  // character, so the browser cannot read it as another site.
  var LOCAL_PATH = /^\/(?![\/\\])[^\\\u0000- \u007f]*$/; // eslint-disable-line no-control-regex, no-useless-escape
  // Path segments of the pages that belong to the login itself. Coming back to them
  // would loop or dead-end. "oidc" is where logout and token expiry send the tab,
  // and the server answers it with the app.
  var LOGIN_PAGE = /^(oidc|unauthorized|unauthorized\.html|auth|callback\.html|silent-renew\.html)$/i;
  var MAX_DECODES = 5;

  function decode(text) {
    for (var i = 0; i < MAX_DECODES; i++) {
      var next = text.replace(/%([0-9a-f]{2})/gi, function(match, hex) {
        return String.fromCharCode(parseInt(hex, 16));
      });
      if (next === text) return text;
      text = next;
    }
    return null; // still changing after several passes: do not trust it
  }

  // Any decoded segment of the path may be a login page, not only the first: the
  // server and the browser resolve "." and ".." (and merge "//") in their own way,
  // so a later segment can end up in front.
  function isLoginPage(value) {
    var decoded = decode(value.split(/[?#]/)[0]);
    if (decoded === null) return true;
    var parts = decoded.replace(/\\/g, "/").split("/");
    for (var i = 0; i < parts.length; i++) {
      if (LOGIN_PAGE.test(parts[i])) return true;
    }
    return false;
  }

  function target(state, fallback) {
    var value = state && typeof state === "object" ? state.returnUrl : undefined;
    if (typeof value !== "string" || value.length > MAX_LENGTH) return fallback;
    if (!LOCAL_PATH.test(value) || isLoginPage(value)) return fallback;
    return value;
  }

  return { target: target };
})();

if (typeof module !== "undefined" && module.exports) {
  module.exports = LoginReturn;
}
